declare namespace $ {

	type $mol_view__sub_bog_smalljs_versus_case_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['controls_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['columns'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_versus_case_frame__uri_bog_smalljs_versus_case_7 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['frame_uri'] >
		,
		ReturnType< $bog_smalljs_versus_case_frame['uri'] >
	>
	type $bog_smalljs_versus_case_frame__frame_title_bog_smalljs_versus_case_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['frame_title'] >
		,
		ReturnType< $bog_smalljs_versus_case_frame['frame_title'] >
	>
	type $bog_smalljs_versus_case_frame__loaded_bog_smalljs_versus_case_9 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['frame_loaded'] >
		,
		ReturnType< $bog_smalljs_versus_case_frame['loaded'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_10 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['card_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__enabled_bog_smalljs_versus_case_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['run_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_smalljs_versus_case_14 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['run'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_smalljs_versus_case_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_versus_case_status__status_bog_smalljs_versus_case_18 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['status'] >
		,
		ReturnType< $bog_smalljs_versus_case_status['status'] >
	>
	type $bog_smalljs_versus_case_status__icon_bog_smalljs_versus_case_19 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['status_icon'] >
		,
		ReturnType< $bog_smalljs_versus_case_status['icon'] >
	>
	type $bog_smalljs_versus_case_status__text_bog_smalljs_versus_case_20 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['status_text'] >
		,
		ReturnType< $bog_smalljs_versus_case_status['text'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_22 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_case['metric_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_case extends $mol_view {
		Title( ): $mol_view
		Hint( ): $mol_view
		Head( ): $mol_view
		controls_content( ): readonly(any)[]
		Controls( ): $mol_view
		columns( ): readonly(any)[]
		Columns( ): $mol_view
		run_enabled( ): boolean
		run( next?: any ): any
		run_label( ): string
		run_hint( ): string
		framework_name( id: any): string
		Label( id: any): $mol_view
		frame_uri( id: any): string
		frame_title( id: any): string
		frame_loaded( id: any, next?: any ): any
		Frame( id: any): $bog_smalljs_versus_case_frame
		card_content( id: any): readonly(any)[]
		Card( id: any): $mol_view
		status( id: any): string
		status_icon( id: any): string
		status_text( id: any): string
		observed( id: any): string
		metric_rows( id: any): readonly(any)[]
		metric_name( id: any): string
		Metric_name( id: any): $mol_view
		metric_value( id: any): string
		Metric_value( id: any): $mol_view
		note( id: any): string
		case_id( ): string
		lights( ): string
		title( ): string
		hint( ): string
		status_idle( ): string
		status_running( ): string
		status_ok( ): string
		status_warn( ): string
		status_fail( ): string
		status_error( ): string
		status_invalid( ): string
		error_timeout( ): string
		error_not_loaded( ): string
		run_hint_broken( ): string
		invalid_tab_hidden( ): string
		invalid_timers_throttled( ): string
		invalid_frame_offscreen( ): string
		invalid_other( ): string
		run_hint_hidden( ): string
		run_hint_loading( ): string
		sub( ): readonly(any)[]
		Run( ): $mol_button_major
		Run_hint( ): $mol_view
		Column( id: any): $mol_view
		Status( id: any): $bog_smalljs_versus_case_status
		Observed( id: any): $mol_view
		Metrics( id: any): $mol_view
		Metric( id: any): $mol_view
		Note( id: any): $mol_view
	}
	
	type $mol_view__sub_bog_smalljs_versus_case_status_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_case_status_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_case_status extends $mol_view {
		Icon( ): $mol_view
		Text( ): $mol_view
		status( ): string
		icon( ): string
		text( ): string
		attr( ): ({ 
			'bog_smalljs_versus_status': ReturnType< $bog_smalljs_versus_case_status['status'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
	export class $bog_smalljs_versus_case_frame extends $mol_view {
		loaded( next?: any ): any
		dom_name( ): string
		uri( ): string
		frame_title( ): string
		sub( ): readonly(any)[]
		event( ): ({ 
			load( next?: ReturnType< $bog_smalljs_versus_case_frame['loaded'] > ): ReturnType< $bog_smalljs_versus_case_frame['loaded'] >,
		})  & ReturnType< $mol_view['event'] >
		attr( ): ({ 
			'src': ReturnType< $bog_smalljs_versus_case_frame['uri'] >,
			'title': ReturnType< $bog_smalljs_versus_case_frame['frame_title'] >,
			'loading': string,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=case.view.tree.d.ts.map